//  gtag events
const sendEvent = (name) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name);
    }

    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("event", name);
    }
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      console.error("[sendEvent]", name, err?.message);
    }
  }
};

export default sendEvent;



